/**
 * On page load
 **/
$(document).ready( function(){
    ToggleContent();
    $('.nav-secondary .menu li a').click(function (a) {
        if (this.hash) {
            a.preventDefault();
            var hash = this.hash;
            history.pushState({}, "", this.href);
            $('html, body').animate({
                scrollTop: ($(hash).offset().top - 75)
            },500);
        }
    });
});

function ToggleContent(){
    $('.toggle-button').click(function(e){
    	e.preventDefault();
        // $(this).parent('.togglable').children('.togglable-content').slideToggle(200);
        $(this).closest('.togglable').find('.togglable-content').first().slideToggle(200);
        $(this).toggleClass('open');
        if( $(this).children('.fa').length ){
        	$(this).children('.fa').toggleClass('fa-angle-right');
        	$(this).children('.fa').toggleClass('fa-angle-down');
        }
    });
}


// WEBPACK FOOTER //
// ./app/js/global/effects.js